import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import axios from "axios";
import config from "./config";
import apiBase from "./utils/apiBase";
import { loadBranding } from "./utils/branding";

if (typeof config.apiBase !== "string") {
  // eslint-disable-next-line no-console
  console.error("frontend/src/config.js is out of date: copy env/config-<env>.js over it");
}

// Relative URLs: the API is on this origin unless REACT_APP_API_URL says otherwise.
const base = apiBase();
if (base) axios.defaults.baseURL = base;

// Branding (product name, logo, legal links) - fetched once, shared by every page.
loadBranding();

ReactDOM.render(
  <>
    <BrowserRouter>
      {/* `url` reaches CustomBPMN (via {...props}), which fetches the diagram with it. */}
      <App url={base} />
    </BrowserRouter>
  </>,
  document.getElementById("root")
);
